import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataCacheService {
  private dataPrefix: string = 'data-cache:';

  saveData(dataName: string, data: any): void {
    //console.log(`saving cache data for: ${dataName}`, data);
    localStorage.setItem(this.dataPrefix + dataName, JSON.stringify(data));
  }

  loadData(dataName: string): any {
    return JSON.parse(localStorage.getItem(this.dataPrefix + dataName));
  }
}
